export const LOGIN_COLORS = {
  primary: '#0066B2',
  primaryHover: '#005494',
  primaryLight: '#E8F2FA',
  primaryMuted: '#B3D1E8',
  pageBg: '#FFFFFF',
  /** Literal white — do not use Tailwind `bg-white`/`text-white` (those map to theme `--white`, which is dark in dark mode). */
  pureWhite: '#FFFFFF',
  cardShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
  inputBorder: '#D0D5DD',
  inputBg: '#FFFFFF',
  inputText: '#252728',
  ssoButtonBorder: '#EAEAEA',
  textPrimary: '#101828',
  textSecondary: '#252728',
  textMuted: '#667085',
  textLabel: '#344054',
  textPlaceholder: '#98A2B3',
  divider: '#CACBCB',
  heroTitle: '#FBFBFB',
  heroTagline: '#B3D1E8',
} as const;
